export enum MembershipBillingFrequency {
    MONTHLY = 'monthly',
    QUARTERLY = 'quarterly',
    YEARLY = 'yearly',
}

export const MEMBERSHIP_BILLING_FREQUENCIES: MembershipBillingFrequency[] =
    Object.values(MembershipBillingFrequency);

export type StripeSubscriptionStatus =
    | 'active'
    | 'canceled'
    | 'incomplete'
    | 'incomplete_expired'
    | 'past_due'
    | 'paused'
    | 'trialing'
    | 'unpaid'; // Stripe.Subscription.Status - https://docs.stripe.com/billing/subscriptions/webhooks#state-changes
